import { module } from 'angular';
import iconHelpComponent from './icon-help.component';

export default module('app')
	.component('iconHelp', iconHelpComponent)
	.name;
